module.exports = __webpack_public_path__ + "static/instagram-logo-2b5415f38037c993d589173f7d36d8e0.png";